import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { useApiWindAlerts } from '@/composables/useApiWindAlerts'


export let useWindAlertStore = defineStore('windAlertStore', () => {
  const apiWindAlerts = useApiWindAlerts();

  const alerts = ref(null);
  const alertDevices = ref(null);

  const deviceTypeMap = {
    'E-Mail': { id: 1, icon: 'envelope', viewKey: 'email', typeDisplay: 'Email' },
    // 'Mobile': { id: 2, icon: 'text-message', viewKey: 'mobile', typeDisplay: 'Text Message' }, // 'Mobile' (text messages) is not supported at this time
    'Android': { id: 3, icon: 'android-logo', viewKey: 'android', typeDisplay: 'Android' },
    'iPhone': { id: 4, icon: 'apple-logo', viewKey: 'iphone', typeDisplay: 'iOS' },
  };

  const alertsSortedBySpot = computed(() => {
    const sortedAlerts = {}

    if (!alerts.value || alerts.value.length === 0) return sortedAlerts;

    alerts.value.forEach(alert => {
      if (!sortedAlerts[alert.spot_name]) {
        sortedAlerts[alert.spot_name] = []
      }

      sortedAlerts[alert.spot_name].push(alert);
    });

    return sortedAlerts;
  })

  async function addAlert(options) {
    const { data } = await apiWindAlerts.addAlert(options);

    return data.value;
  }

  async function updateAlert(options) {
    const { data } = await apiWindAlerts.updateAlert(options);

    return data.value;
  }

  async function getWindAlerts(settings, overrideCache = false) {
      const { data } = await apiWindAlerts.getAlerts(settings, overrideCache)
      alerts.value = data.value.alerts;

      return alerts.value;
  }

  async function getAlertDevices(settings, overrideCache = false) {
    const { data } = await apiWindAlerts.getAlertDevices(settings, overrideCache);
    alertDevices.value = (data.value.alert_devices || []).map(device => {
      const raw = device.enabled ?? device.alerts_enabled
      return {
        ...device,
        enabled: raw === true || raw === 'true' || raw === 1 || raw === '1'
      }
    }).filter(device => device.type.toLowerCase() !== 'mobile');

    return alertDevices.value;
  }

  const getAlertDevice = (deviceId) => {
    return alertDevices.value.find(device => device.id === deviceId);
  }

  async function changeAlertStatus(alertId, enabled) {
    const { data } = await apiWindAlerts.changeAlertStatus({ alert_id: alertId, enabled });
    return data.value;
  }

  async function deleteAlert(alertId) {
    const { data } = await apiWindAlerts.deleteAlert({ alert_id: alertId });
    // Remove from local state
    if (alerts.value) {
      alerts.value = alerts.value.filter(a => a.id !== alertId);
    }
    return data.value;
  }

  return {
    alerts,
    alertDevices,
    alertsSortedBySpot,
    deviceTypeMap,
    addAlert,
    updateAlert,
    getAlertDevice,
    getAlertDevices,
    getWindAlerts,
    changeAlertStatus,
    deleteAlert,
  }
})
